type FeatherLogoProps = {
  className?: string;
};

/** The site mark: a single peacock train feather eye. Decorative only. */
export function FeatherLogo({ className }: FeatherLogoProps) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
      <path
        d="M32 40 C32 48 31 56 29 62"
        stroke="currentColor"
        strokeWidth="3.5"
        fill="none"
        strokeLinecap="round"
        opacity="0.6"
      />
      <ellipse cx="32" cy="24" rx="19" ry="23" fill="#0c7a4d" />
      <ellipse cx="32" cy="26" rx="14" ry="17" fill="#c9a227" />
      <ellipse cx="32" cy="28" rx="10" ry="12" fill="#12758c" />
      <ellipse cx="32" cy="30" rx="5.5" ry="7" fill="#041f27" />
      <ellipse cx="29.5" cy="21" rx="4.5" ry="6" fill="#ffffff" opacity="0.18" />
    </svg>
  );
}
